import { AvatarManifest } from "../avatar/rig";
export interface FacePreviewSettings {
  blink: boolean;
  speech: boolean;
  expressions: Record<string, number>;
}
export const emptyFacePreview: FacePreviewSettings = {
  blink: false,
  speech: false,
  expressions: {},
};
const labels: Record<string, string> = {
  blinkLeft: "Close left eye",
  blinkRight: "Close right eye",
  jawOpen: "Open mouth",
  smile: "Smile",
  smileLeft: "Smile left",
  smileRight: "Smile right",
  browUp: "Raise brows",
};
export default function AvatarFacePanel({
  manifest,
  value,
  onChange,
}: {
  manifest: AvatarManifest | null;
  value: FacePreviewSettings;
  onChange: (value: FacePreviewSettings) => void;
}) {
  const channels = Object.keys(manifest?.face || {}).filter(
    (k) => manifest!.face[k].length,
  );
  const mouth = channels.includes("jawOpen");
  return (
    <section
      className="avatar-rig-inspector avatar-face-panel"
      aria-label="Face preview"
    >
      <h3>Face preview</h3>
      {!manifest ? (
        <p>Inspecting face…</p>
      ) : channels.length === 0 ? (
        <p>
          This character has no facial shape controls yet. Eyelids and mouth
          shapes must be added to the model before these previews can move its
          face.
        </p>
      ) : (
        <p>Preview the facial shapes detected on this character.</p>
      )}
      <label>
        <input
          type="checkbox"
          disabled={!manifest?.capabilities.blink}
          checked={value.blink}
          onChange={(e) => onChange({ ...value, blink: e.target.checked })}
        />{" "}
        Automatic blinking
      </label>
      <label>
        <input
          type="checkbox"
          disabled={!mouth}
          checked={value.speech}
          onChange={(e) => onChange({ ...value, speech: e.target.checked })}
        />{" "}
        Simulated speech
      </label>
      <p>
        Speech preview uses a generated rhythm. It does not turn on your
        microphone.
      </p>
      {channels.map((channel) => (
        <label key={channel}>
          {labels[channel] || channel.replace("viseme_", "Mouth sound: ")}{" "}
          <output>
            {Math.round((value.expressions[channel] || 0) * 100)}%
          </output>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={value.expressions[channel] || 0}
            onChange={(e) =>
              onChange({
                ...value,
                expressions: {
                  ...value.expressions,
                  [channel]: Number(e.target.value),
                },
              })
            }
          />
        </label>
      ))}
      <button type="button" onClick={() => onChange(emptyFacePreview)}>
        Reset face
      </button>
    </section>
  );
}
